<template>
    <div>
        <custom-tooltip v-model="tooltipOpen" border>
            <app-button circle icon color="brand-magenta" @click="openModal">
                ⚙
            </app-button>
            <template #tooltip>Configurar lista</template>
        </custom-tooltip>
        <app-dialog v-model="isOpen" size="sm">
            <template #header>
                <h4 class="text-lg text-theme-base font-semibold">
                    Configurar lista
                </h4>
            </template>
            <div class="flex flex-col gap-4">
                <div>
                    <p class="text-sm text-theme-muted mb-2">
                        Resultados por página
                    </p>
                    <div class="flex gap-2 flex-wrap">
                        <app-button
                            v-for="size in pageSizeOptions"
                            :key="size"
                            :color="
                                localPageSize === size ? 'brand-purple' : ''
                            "
                            :relief="localPageSize !== size"
                            @click="localPageSize = size"
                        >
                            {{ size }}
                        </app-button>
                    </div>
                </div>
                <div v-if="sortOptions.length">
                    <p class="text-sm text-theme-muted mb-2">Ordenar por</p>
                    <div class="flex flex-col gap-1">
                        <app-button
                            v-for="option in sortOptions"
                            :key="option.value"
                            :color="
                                localSort === option.value ? 'brand-purple' : ''
                            "
                            :relief="localSort !== option.value"
                            class="text-left justify-start"
                            @click="localSort = option.value"
                        >
                            {{ option.label }}
                        </app-button>
                    </div>
                </div>
                <app-button color="success" @click="apply">
                    Aplicar
                </app-button>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "ListSettingsButton",
    components: { AppDialog },
    props: {
        value: {
            type: Object,
            default: () => ({ pageSize: 24, sortConfig: null })
        },
        pageSizeOptions: {
            type: Array,
            default: () => [12, 24, 48, 96]
        },
        sortOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        const sortConfig = this.value?.sortConfig;
        return {
            isOpen: false,
            tooltipOpen: false,
            localPageSize: this.value?.pageSize ?? 24,
            localSort: sortConfig
                ? `${sortConfig.orderBy}:${sortConfig.orderType}`
                : null
        };
    },
    watch: {
        value(newVal) {
            this.localPageSize = newVal?.pageSize ?? 12;
            const sc = newVal?.sortConfig;
            this.localSort = sc ? `${sc.orderBy}:${sc.orderType}` : null;
        }
    },
    methods: {
        openModal() {
            this.tooltipOpen = false;
            this.isOpen = true;
        },
        apply() {
            this.isOpen = false;
            const sortConfig = this.localSort
                ? {
                      orderBy: this.localSort.split(":")[0],
                      orderType: this.localSort.split(":")[1]
                  }
                : null;
            const result = { pageSize: this.localPageSize, sortConfig };
            this.$emit("input", result);
            this.$emit("change", result);
        }
    }
};
</script>
